export default class StickyMenu{

  constructor(opts={position: 0}){
    this.position = opts.position;
    this.navbar = $('.navbar-main');

    /**
     * verifica a posição e seta o fixed no menu
     */
    (this.getPosition() < 1) ? this.removeSticky() : this.setSticky();
  }

  setSticky(){
    if (!this.navbar.hasClass('is-sticky')){
      this.navbar.addClass('is-sticky');
    }
  }

  removeSticky(){
    if (this.navbar.hasClass('is-sticky')){
      this.navbar.removeClass('is-sticky');
    }
  }

  getPosition(){
    return this.position;
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/sticky_menu.js
// module id = 24
// module chunks = 0